import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastModule } from 'primeng/toast';
import { ButtonModule} from 'primeng/button';
import { TabViewModule} from 'primeng/tabview';
// import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import {CalendarModule} from 'primeng/calendar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';

import {MessageService} from 'primeng/api';


import { AccordionModule } from 'primeng/accordion';
import { usuarioListComponent } from './usuarios-list/usuario-list.component';
import { usuarioCreateComponent } from './usuarios-create/usuarios-create.component';

import { AppUsuarioRoutingModule } from './app.usuario.routes';
import { GenericDesplegableModule } from 'src/app/components/deplegable/generic-dropdown/generic-dropdown.module';
import { SimpleTableModule } from 'src/app/components/table/simple-table/simple-table.modules';

@NgModule({
    declarations: [
        usuarioListComponent,
        usuarioCreateComponent
    ],
    imports: [ 
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AccordionModule,
        ToastModule,
        ButtonModule,
        TabViewModule,
        TableModule,
        DialogModule,
        DropdownModule,
        InputTextModule,
        MultiSelectModule,
        SliderModule,
        CalendarModule,
        RadioButtonModule,
        InputSwitchModule,
        ConfirmDialogModule,
        AppUsuarioRoutingModule,
        GenericDesplegableModule,
        SimpleTableModule
        
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [

    ],

    providers: [
        MessageService,
        ConfirmationService,
      
    ],
    bootstrap: []
})
export class UsuarioModule {}